import { AnchorNode } from '../anchor';
import { clipSelectionRange } from './clipSelectionRange';
import { getNodePathFromNodeOffset } from './getNodePathFromNodeOffset';
import { NodeTextNavigation } from './NodeTextNavigation';
import { RangeInternal } from './RangeInternal';
import { resolvePathWithOffset } from './resolvePathWithOffset';

export function extendToTextNode(root: AnchorNode, path: string) {
    const match = resolvePathWithOffset(root, path);
    if (!match) { return null; }

    const start = new NodeTextNavigation(match.anchor.node).forward(match.offset).start();
    const end = new NodeTextNavigation(match.anchor.node).forward(match.offset).end();

    const clipped = clipSelectionRange(root, new RangeInternal(start.domNode(), start.offset(), end.domNode(), end.offset()));
    if (!clipped) { return null; }

    const pathStart = getNodePathFromNodeOffset(root, clipped.startContainer, clipped.startOffset);
    if (!pathStart) { return null; }

    const pathEnd = getNodePathFromNodeOffset(root, clipped.endContainer, clipped.endOffset);
    if (!pathEnd) { return null; }

    return { pathEnd, pathStart };
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/extendToTextNode.tsx